import * as anodum from 'anodum';
import textFormatting from '../../text-formatting';

const getSelectedElementsByTag = (tagName) => {
  const selection = textFormatting.accessors.getAdvancedSelection();
  if (!selection.rangeCount) return [];

  const range = selection.getRangeAt(0);
  const nodes = range.getNodes();

  const { anchorNode, focusNode } = selection;
  const isSelectionInsideOneElement =
    anchorNode.parentElement.closest(tagName) === focusNode.parentElement.closest(tagName);

  if (nodes.length === 1) {
    const parentElement = nodes[0].parentNode;
    const closestElement = parentElement.closest(tagName);
    return closestElement ? [closestElement] : [];
  }

  if (isSelectionInsideOneElement) {
    nodes.push(anchorNode.parentElement.closest(tagName));
  }

  const elementsNodes = nodes.filter((node) => anodum.isElementNode(node));
  return elementsNodes.filter((node) => anodum.isTag(node, tagName));
};

export default getSelectedElementsByTag;
